import React, {createContext, useContext, useState} from 'react';

const AppDataContext = React.createContext({});

export function useAppData() {
    return useContext(AppDataContext);
}

export function AppDataProvider({children}) {
    /// This is the context provider for data related to the app version and build info
    const [appData, setAppData] = useState({
        buildInfo: null,
        userVersionUpToDate: true,
    });

    const updateAppData = newData => setAppData(newData);

    return (
        <AppDataContext.Provider value={{appData, updateAppData}}>
            {children}
        </AppDataContext.Provider>
    );
}